import React from "react";
import {Link} from "react-router-dom";

export const OpenbrainLogoLink = () => (
    <Link
        to="/"
        style={{
          fontSize: 12,
          textDecoration: "none",
          color: "#252525",
          display: "inline-flex",
        }}
    >
      <img src="/logo-black.svg" alt="OpenBrain" width={100}/>
    </Link>
);